import { SVGProps, Ref, forwardRef } from 'react';

export const GamepadFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 3.5c-6 0-8 2-8 8v3.75C0 19 1.503 20.5 3.5 20.5c1.394 0 2.463-.862 3.61-1.786C8.431 17.648 9.856 16.5 12 16.5s3.568 1.148 4.89 2.214c1.147.924 2.216 1.786 3.61 1.786 1.997 0 3.5-1.5 3.5-5.25V11.5c0-6-2-8-8-8zM18.35 10c0 .304-.078.511-.174.627-.073.087-.236.223-.676.223s-.603-.136-.676-.223c-.096-.116-.174-.323-.174-.627s.078-.511.174-.627c.073-.087.236-.223.676-.223s.603.136.676.223c.096.116.174.323.174.627m-.85 2.65c.873 0 1.584-.302 2.059-.87.45-.541.591-1.209.591-1.78s-.141-1.239-.591-1.78c-.475-.569-1.186-.87-2.059-.87s-1.584.301-2.059.87c-.45.541-.591 1.209-.591 1.78s.141 1.239.591 1.78c.475.569 1.186.87 2.059.87m-11-3.923 1.364-1.363 1.272 1.272L7.773 10l1.363 1.364-1.272 1.273L6.5 11.273l-1.364 1.363-1.272-1.272L5.227 10 3.864 8.637l1.272-1.273z"
                fill="currentColor"
            />
        </g>
    </svg>
));
GamepadFilledSize24Glyph.displayName = 'GamepadFilledSize24Glyph';
